interface Environment {
  apiUrl: string;
  webUrl: string;
  editorUrl: string;
  apiBackendUrl: string;
  amplitudeKey: string;
  intercomKey: string;
  automationApiUrl: string;
  googleAnalyticsUA: string;
  region: string;
  identityPoolId: string;
  assetUploadsBucket: string;
  optimizeAssetApiUrl: string;
  enqueueUrl: string;
}

interface Environments {
  local: Environment;
  develepe: Environment;
  prod: Environment;
}

export const environments: Environments = {
  local: {
    apiUrl: 'http://dev.wideo.co:8082/wideoo-api-rest',
    webUrl: 'http://dev.wideo.co:8080',
    editorUrl: 'http://dev.wideo.co:3000/editor',
    maticUrl: 'https://editordev.wideo.co/matic',
    apiBackendUrl: 'https://editorbackend.wideo.co',
    amplitudeKey: '6054ea1522e279b22b01fd8bb77fae46',
    intercomKey: 'uwg0gbbj',
    automationApiUrl: 'https://automationapi.dev.wideo.co',
    googleAnalyticsUA: 'G-V78E9N3JMF',
    region: "us-east-1",
    identityPoolId: 'us-east-1:601f8d87-b37d-4f13-80c7-c755109b851f',
    assetUploadsBucket: 'dev.asset-uploads.wideo.co',
    optimizeAssetApiUrl: 'wss://eys4pyr3ik.execute-api.us-east-1.amazonaws.com/dev',
    enqueueUrl: 'https://mhsk8lbcmh.execute-api.us-east-1.amazonaws.com/dev/batch/enqueue'
  },
  develepe: {
    apiUrl: 'https://develepe.wideo.co/wideoo-api-rest',
    webUrl: 'https://develepe.wideo.co',
    editorUrl: 'https://editordev.wideo.co/editor',
    maticUrl: 'https://editordev.wideo.co/matic',
    apiBackendUrl: 'https://editorbackend.wideo.co',
    amplitudeKey: '6054ea1522e279b22b01fd8bb77fae46',
    intercomKey: 'uwg0gbbj',
    automationApiUrl: 'https://automationapi.dev.wideo.co',
    googleAnalyticsUA: 'G-V78E9N3JMF',
    region: "us-east-1",
    identityPoolId: 'us-east-1:601f8d87-b37d-4f13-80c7-c755109b851f',
    assetUploadsBucket: 'dev.asset-uploads.wideo.co',
    optimizeAssetApiUrl: 'wss://eys4pyr3ik.execute-api.us-east-1.amazonaws.com/dev',
    enqueueUrl: 'https://mhsk8lbcmh.execute-api.us-east-1.amazonaws.com/dev/batch/enqueue'
  },
  prod: {
    apiUrl: 'https://papi.wideo.co',
    webUrl: 'https://app.wideo.co',
    editorUrl: 'https://editor.wideo.co/editor',
    maticUrl: 'https://editor.wideo.co/matic',
    apiBackendUrl: 'https://editorbackend.wideo.co',
    amplitudeKey: '8b9fe25b9c9fcc062243e6b95b0964a6',
    intercomKey: 'mte3ekjy',
    automationApiUrl: 'https://automationapi.wideo.co',
    googleAnalyticsUA: 'G-K579ZYENM7',
    region: "us-east-1",
    identityPoolId: 'us-east-1:2f8cb59b-0753-4782-a590-89c4d0e2d1fd',
    assetUploadsBucket: 'asset-uploads.wideo.co',
    optimizeAssetApiUrl: 'wss://f5f6jfzs34.execute-api.us-east-1.amazonaws.com/prod',
    enqueueUrl: 'https://09bcoidb07.execute-api.us-east-1.amazonaws.com/prod/batch/enqueue'
  }
}
